var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"TransporterLink",attrs:{"href":_vm.getLink(),"target":"_blank"}},[_vm._v(_vm._s(_vm.pack.trackingNumber))])}
var staticRenderFns = []

export { render, staticRenderFns }